"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _consts = _interopRequireDefault(require("./consts"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getSpacingToken = function getSpacingToken(_ref) {
  var _tokens;

  var spaceAfter = _ref.spaceAfter,
      theme = _ref.theme;
  var tokens = (_tokens = {}, _defineProperty(_tokens, _consts.default.NONE, "0"), _defineProperty(_tokens, _consts.default.SMALLEST, theme.orbit.spaceXXSmall), _defineProperty(_tokens, _consts.default.SMALL, theme.orbit.spaceXSmall), _defineProperty(_tokens, _consts.default.NORMAL, theme.orbit.spaceSmall), _defineProperty(_tokens, _consts.default.MEDIUM, theme.orbit.spaceMedium), _defineProperty(_tokens, _consts.default.LARGE, theme.orbit.spaceLarge), _defineProperty(_tokens, _consts.default.LARGEST, theme.orbit.spaceXLarge), _tokens);
  return spaceAfter && tokens[spaceAfter];
};

var _default = getSpacingToken;
exports.default = _default;